import { Divider, Grid, Link, Stack, Typography } from "@mui/material";
import WushCard from "../../layout/WushCard";
import useCheckoutStore from "../../../stores/public/useCheckoutStore";
import CheckoutReservation from "./reservation/CheckoutReservation";
import ReservationSummary from "./reservation/checkout/components/ReservationSummary";

export default function StorePage({ storePage }) {
  const { pricePreview, reservation } = useCheckoutStore();

  return (
    <Grid container px="20%" py={5} spacing={2}>
      <Grid item sm={8}>
        <WushCard
          bgcolor={"#ffffff"}
        >
          <Stack p={2}>
            <CheckoutReservation storePage={storePage} />
          </Stack>
        </WushCard>
        <Link href="http://localhost:3002/storefront">Test</Link>
      </Grid>
      <Grid item sm={4}>
        <WushCard
          bgcolor={"#ffffff"}
        >
          <Stack p={2}>
            <Stack>
              <Stack mb={1}>
                <img width="100%" style={{ borderRadius: "15px" }} src={storePage.image_url} alt="Store image" />
              </Stack>
              <Stack>
                <Typography variant="h6">
                  {storePage.name}
                </Typography>
                <Typography variant="body1">
                  {storePage.description}
                </Typography>
              </Stack>
              <Stack my={2}>
                <Divider />
              </Stack>
            </Stack>
            <Stack item sm={12}>
              {
                reservation ? <ReservationSummary reservation={reservation} />
                :
                <Stack>
                  <Typography variant="h6" fontWeight="700">
                    Total cost: ${pricePreview / 100}
                  </Typography>
                </Stack>
              }

            </Stack>
          </Stack>
        </WushCard>
      </Grid>
    </Grid>
  );
}